import React from "react";
import { Checkbox, Space } from "antd";
import translate from "../../../../i18n/translate";

export default function RoomCount({ searchParams, setSearchParams }) {

  return (
    <div className="filter-card">
      <p>{translate("filter.room_count")}</p>
      <div className="checkbox-container">
        <div>
          <Checkbox
            checked={searchParams.roomCount?.split(",").filter(Boolean).length === 3}
            onClick={() => {
              const allSelected = searchParams.roomCount?.split(",").filter(Boolean).length === 3;
              setSearchParams({
                ...searchParams,
                roomCount: allSelected ? "" : "1+,2+,3+",
              });
            }}
          >
            {translate("filter.all")}
          </Checkbox>
        </div>
        {["1+", "2+", "3+"].map((count) => (
          <div key={count}>
            <Checkbox
              checked={searchParams.roomCount
                ?.split(",")
                .includes(String(count))}
              onClick={(e) => {
                e.target.checked
                  ? setSearchParams({
                      ...searchParams,
                      roomCount: [
                        ...(searchParams.roomCount?.split(",") || []),
                        count,
                      ].join(","),
                    })
                  : setSearchParams({
                      ...searchParams,
                      roomCount: searchParams.roomCount
                        ?.split(",")
                        .filter((currentCount) => count != currentCount)
                        .join(","),
                    });
              }}
            >
              {count}
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
}
